import React from 'react';
import { IconPack, library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faCompress,
  faExpand,
  faSearch,
} from '@fortawesome/pro-regular-svg-icons';
import * as Sentry from '@sentry/browser';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import * as serviceWorkerRegistration from 'serviceWorkerRegistration';
import { persistor, store } from 'store';

import 'scss/index.scss';
import '@cognitiv/cyprus-ui/dist/index.css';

import 'utils/prototype';

import { App } from 'App';

const { REACT_APP_SENTRY_DSN, REACT_APP_ENVIRONMENT } = process.env;

library.add({
  faSearch,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faCompress,
  faExpand,
} as IconPack);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
global.store = store;

if (REACT_APP_ENVIRONMENT !== 'development') {
  Sentry.init({
    dsn: REACT_APP_SENTRY_DSN,
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 0.1,
  });
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
